package com.karyadina.cloudsync.service

import com.karyadina.cloudsync.model.SharedLink
import com.karyadina.cloudsync.util.TimeUtil

/**
 * Minimal Shared Link Storage implementation
 */
class SharedLinkStorageImpl : SharedLinkStorage {
    
    private val linkMap = mutableMapOf<String, SharedLink>()
    
    override suspend fun saveLink(link: SharedLink): Result<Unit> {
        linkMap[link.id] = link
        return Result.success(Unit)
    }
    
    override suspend fun getLink(token: String): Result<SharedLink?> {
        return Result.success(linkMap[token])
    }
    
    override suspend fun getAllLinks(): Result<List<SharedLink>> {
        return Result.success(linkMap.values.toList())
    }
    
    override suspend fun markAsUsed(token: String): Result<Unit> {
        linkMap[token]?.let {
            linkMap[token] = it.copy(used = true)
        }
        return Result.success(Unit)
    }
    
    override suspend fun deleteLink(token: String): Result<Unit> {
        linkMap.remove(token)
        return Result.success(Unit)
    }
    
    override suspend fun deleteExpiredLinks(): Result<Int> {
        val now = TimeUtil.currentTimeMillis()
        val toDelete = linkMap.filter { it.value.expiresAt < now }.keys
        toDelete.forEach { linkMap.remove(it) }
        return Result.success(toDelete.size)
    }
    
    override suspend fun deleteUsedLinks(): Result<Int> {
        val toDelete = linkMap.filter { it.value.used }.keys
        toDelete.forEach { linkMap.remove(it) }
        return Result.success(toDelete.size)
    }
    
    override suspend fun clearAll(): Result<Unit> {
        linkMap.clear()
        return Result.success(Unit)
    }
}
